import React, { useEffect, useState } from "react";
import StatCard from "@/pages/DashboardPage/components/StatCard";
import { getActiveUsersReq } from "@/api/adminApi";

const ActiveAccountsCard = () => {
  const [activeUsers, setActiveUsers] = useState();

  useEffect(() => {
    const fetchActiveUsers = async () => {
      try {
        const response = await getActiveUsersReq();
        setActiveUsers(response.data.activeUsersCount);
      } catch (e) {
        console.error(e);
      }
    };
    fetchActiveUsers();
  }, []);

  return (
    <StatCard value={activeUsers || 0} label="Active Accounts" trend="+2,7%" />
  );
};

export default ActiveAccountsCard;
